// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"u","newsItemBox":"u","img-box":"v","imgBox":"v","img-mask-box":"w","imgMaskBox":"w"};